import React from "react";

import ArchiveAllergyItem from "../../Components/Archive-Items/ArchiveAllergy";
import Layout from "../../Components/Side bar/Layout";

export default function ArchiveAllergy() {
  return (
    <Layout>
      <ArchiveAllergyItem />
    </Layout>
  );
}
